module.exports = __webpack_public_path__ + "static/f5c8120ca1066f43b597c4ba481cd97eb5c75903c91bb80ad7b986f0ec3b321b-cba2bc85a2253748547e13a89cfe0f1e.png";